const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-wirelineupgradecircuit3234234234'; // to be updated

//location form actions
export const setSubscriptionDetails = `SET-WIRELINE-UPGRADE-CIRCUIT-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-WIRELINE-UPGRADE-CIRCUIT-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setPrimaryPlanDetails = `SET-WIRELINE-UPGRADE-CIRCUIT-PRIMARY-PLAN-DETAILS-${actionTypeIdentifier}`;
export const setPlanOptions = `SET-WIRELINE-UPGRADE-CIRCUIT-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELINE-UPGRADE-CIRCUIT-FORM-SUBMITTED-${actionTypeIdentifier}`;


export const wirelineUpgradeCircuitModel = {
    circuitCode: ''
    , circuitId: 0
    , planId: 0
    , planDetails: {
        planComponents: []
    }
    , planDetailsModel: []
    , businessJustification: ''
    , additionalInformation: ''
}